// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('article.productApproval', {
    controller: 'ProductApprovalController as vm',
    parent: 'article',
    url: '/product-approval?searchTerm&supplierId&branchId&state',
    templateUrl: 'main/article/productApproval/productApproval.tpl.html',
    data: { pageTitle: 'Product approval' },
  });
};

class ProductApprovalController {
  constructor($rootScope, article) {
    'ngInject';

    $rootScope.pageTitle = `${article.itemCode || ''} - Product approval`;

    this.article = article;
  }
}

angular
  .module('main.article.productApproval', [])
  .config(config)
  .controller('ProductApprovalController', ProductApprovalController);
